import { useInfiniteQuery } from "@tanstack/react-query";
import { queryAccessLog, type AccessLogFilters } from "./api";

export function useAccessLog(filters: AccessLogFilters) {
  return useInfiniteQuery({
    queryKey: ["portal", "security-access-log", filters],
    queryFn: ({ pageParam }) => queryAccessLog(filters, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.meta.next ?? undefined,
  });
}
